import { render, staticRenderFns } from "./NotificationAlert.vue?vue&type=template&id=658d1202&"
import script from "./NotificationAlert.vue?vue&type=script&lang=js&"
export * from "./NotificationAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports